// extracted by mini-css-extract-plugin
export default {"to":"SearchResultList_to__hExMu","emptyContainer":"SearchResultList_emptyContainer__3oNI-"};